import { Icon } from '@toggle/design-system';
import React from 'react';

import { usePostAlerts } from '~/react-query-hooks/events/use-event-alerts/useEventAlerts';

import * as S from './AlertsIcon.styles';

export const AlertsIcon = () => {
  const { data } = usePostAlerts({ count_only: true });
  const unreadCount = data?.pages[0]?.unread_count ?? 0;

  return (
    <S.AlertsIconRoot>
      <Icon iconName="NotificationLine" size={24} />
      {unreadCount > 0 && (
        <S.UnreadBadge>{unreadCount > 9 ? '9+' : unreadCount}</S.UnreadBadge>
      )}
    </S.AlertsIconRoot>
  );
};
